import { Bingo, ClassicJackpot, Diamond, Instant, LiveDealer, MyActivity, Party, Roulette, Slots, TableGame } from '@shared/icons';
import { ROUTES } from '@shared/utils';
import type { CategoryType } from './types';

const { NEW_GAMES, SLOTS, JACKPOT_OVERDRIVE, JACKPOTS_GAMES, TABLE_GAMES, LIVE_DEALER, SLINGO, CRASH_GAMES, INSTANT_WIN, MEGAWAYS, DROPS_AND_WINS } = ROUTES.CASINO;

// Will be replaced by CMS content
// TrackName is added to ensure that categories trackName is in English and consistent across all languages
const casinoCategories: CategoryType[] = [
  {
    id: 'new',
    slug: NEW_GAMES,
    icon: Party,
    trackName: 'New',
  },
  {
    id: 'slots',
    slug: SLOTS,
    icon: Slots,
    trackName: 'Slots',
  },
  {
    id: 'table_games',
    slug: TABLE_GAMES,
    icon: TableGame,
    trackName: 'Table games',
  },
  {
    id: 'jackpot_overdrive',
    slug: JACKPOT_OVERDRIVE,
    icon: Roulette,
    trackName: 'Jackpot overdrive',
  },
  {
    id: 'jackpots',
    slug: JACKPOTS_GAMES,
    icon: ClassicJackpot,
    trackName: 'Jackpots',
  },
  {
    id: 'slingo',
    slug: SLINGO,
    icon: Bingo,
    trackName: 'Slingo',
  },
  {
    id: 'crash_games',
    slug: CRASH_GAMES,
    icon: MyActivity,
    trackName: 'Crash games',
  },
  {
    id: 'instant_win',
    slug: INSTANT_WIN,
    icon: Instant,
    trackName: 'Instant win',
  },
  {
    id: 'megaways',
    slug: MEGAWAYS,
    icon: Slots,
    trackName: 'Megaways',
  },
  {
    id: 'drops_and_wins',
    slug: DROPS_AND_WINS,
    icon: Diamond,
    trackName: 'Drops & Wins',
  },
  {
    id: 'live_dealer',
    slug: LIVE_DEALER,
    icon: LiveDealer,
    trackName: 'Live Casino Games',
  },
];

export { casinoCategories };
